<template>
  <div>
    <div class="card">
      <div class="" v-if="!showButtonInicial && !osEmPause">
        <os-item-pecas :os="os" v-for="(item, index) in items" :key="index + 'p'" :item="item"
          :initAt="initAtendimento">
        </os-item-pecas>

        <div class="card">
          <div class="card-body">
            <div class="row align-items-center">
              <div class="col-1 col-lg-1 text-left striped-sm">
                <input type="checkbox" :disabled="isEncerrada" class="" v-model="btnCheckedServicos" @click="selecionarTodos"/>
              </div>
              <div class="col-8 col-lg-10 text-left ">
                <strong><h5>{{ $t('Selecionar Todos') }}</h5></strong>
              </div>
            </div>
          </div>
        </div>
        <os-item-servico :os="os" v-for="(item, index) in items" :key="index + 's'" :item="item"
          :initAt="initAtendimento" @arrayServicos="insertArrayServicos" @limparArrayServicos="limparArrayServicos">
        </os-item-servico>
      </div>
      <div class="card-body">
        <div class="row">
          <div class="col-12 col-lg-10 text-left striped-sm">
            <div class="d-inline d-lg-block mr-2">{{ $t('Descrição') }}:</div>
            <strong>{{$t('Clique no botão a direita para registrar as peças')}}</strong>
          </div>

          <!-- Botões -->
          <div class="col-12 col-lg-2 col-xl-2 text-left striped-sm mt-md-4 mt-lg-0">
            <div class="row">
              <div class="col-12 d-md-block d-lg-none mb-2">{{$t('Ações')}}</div>
              <div class="col-xs-12 col-md-4 col-lg-12" v-if="isEncerrada">
                <span class="badge badge-secondary p-2 w-100 mb-2">
                  <i class="fas fa-lock mr-1"></i> {{ $t('Somente Consulta') }}
                </span>
              </div>
              <div class="col-xs-12 col-md-4 col-lg-12" v-if="!isEncerrada && showButtonInicial">
                <button class="btn btn-success btn-block mb-2" @click="acaoPreventiva('iniciar')">
                  <i class="fas fa-play"></i> {{$t('Iniciar')}}
                </button>
              </div>
              <div class="col-xs-12 col-md-4 col-lg-12" v-if="!isEncerrada && !showButtonInicial && !osEmPause">
                <button class="btn btn-danger btn-block mb-2" @click="showUploadPecas = true">
                  <i class="fas fa-stop"></i> {{ $t('Encerrar OS') }}
                </button>
              </div>
              <div class="col-xs-12 col-md-4 col-lg-12" v-if="!isEncerrada && !showButtonInicial && !osEmPause && fornecExt">
                <button class="btn btn-warning btn-block mb-2" @click="pausarPreventiva">
                  <i class="fas fa-pause"></i> {{ $t('Pausar') }}
                </button>
              </div>
              <div class="col-xs-12 col-md-4 col-lg-12" v-if="!isEncerrada && !showButtonInicial && osEmPause">
                <button class="btn btn-success btn-block mb-2" @click="continuarPreventiva">
                  <i class="fas fa-play"></i> {{ $t('Continuar') }}
                </button>
              </div>
              <div class="col-xs-12 col-md-4 col-lg-12" v-if="!isEncerrada && !showButtonInicial">
                <button class="btn btn-success btn-block mb-2" @click="showModalItemsFim = true">
                  <i class="fa fa-wrench" aria-hidden="true"></i> {{ $t('Registrar Peças') }}
                </button>
              </div>
              <div class="col-xs-12 col-md-4 col-lg-12" v-if="!isEncerrada && !showButtonInicial && !osEmPause">
                <button class="btn btn-success btn-block mb-2" @click="registrarServicos">
                  <i class="fa fa-user" aria-hidden="true"></i> {{ $t('Registrar Serviços') }}
                </button>
              </div>
              <div class="col-xs-12 col-md-4 col-lg-12" >
                <button class="btn btn-info btn-block mb-2" @click="abrirModalPreventiva">
                  <i class="fa fa-wrench" aria-hidden="true"></i> {{ $t('Visualizar Itens') }}
                </button>
              </div>
              <div class="col-xs-12  col-md-4 col-lg-12" v-if="!isEncerrada">
                <button class="btn btn-primary btn-block mb-2"
                  @click="showModalExterna = true">
                  <i class="fa fa-file-export"></i> {{ $t('OS Externa') }}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <modal-pecas v-if="showModalPecas" :items="allItems" @showModalPecas="showModalPecas = false">
      </modal-pecas>
      <modal-servicos v-if="showModalServicos" @showModalServicos="showModalServicos = false">
      </modal-servicos>
      <modal-upload-pecas v-if="showUploadPecas" @showUploadPecas="showUploadPecas = false"
        @finalizarPreventiva="finalizarPreventivaComAnexo" :os="os">
      </modal-upload-pecas>

      <modal-items-fim @showModalItemsFim="
          (showModalItemsFim = false), (exibeFinalizar = true)
        " @finalizaOS="parar" v-if="showModalItemsFim" :os="os" :tipo_os="'preventiva'">
      </modal-items-fim>

      <modal-items-preventiva
        :item="allItems"
        @showModalItemsPreventiva="showModalItemsPreventiva = false"
      />

      <modal-externa v-if="showModalExterna" @fechaModal="showModalExterna = false" @enviaOsExterna="enviaOsExterna"/>
    </div>
  </div>
</template>
<script>
import ModalServicos from "./ModalServicos.vue";
import ModalUploadPecas from "./ModalUploadPecas.vue";
import ModalPecas from "./ModalPecas.vue";
import OsItemServico from "@/components/Preventivas/OsItemServico";
import OsItemPecas from "@/components/Preventivas/OsItemPecas";
import ModalItemsFim from "../Modais/ModalItemsFim.vue";
import ModalItemsPreventiva from "../Modais/ModalItemsPreventiva.vue";
import ModalExterna from '../Modais/ModalExterna'

export default {
  name: "OsItemPreventiva",
  props: {
    os: {}
  },

  data() {
    return {
      showModalPecas: false,
      showModalServicos: false,
      enabledIniciar: true,
      allItems: [],
      exibirItens: true,
      initAtendimento: false,
      totalServicos: [],
      validaOsExterna: false,
      divPrincipalPreventiva: true,
      showUploadPecas: false,
      showModalItemsFim: false,
      km_veiculo: "",
      obsExterna: "",
      btnCheckedServicos: false,
      showModalItemsPreventiva: false,
      showModalExterna: false
    };
  },
  components: {
    ModalServicos,
    ModalPecas,
    OsItemServico,
    OsItemPecas,
    ModalUploadPecas,
    ModalItemsFim,
    ModalItemsPreventiva,
    ModalExterna
  },
  computed: {
    fornecExt() {
      const filial = JSON.parse(localStorage.filial);

      if (filial.infColab.nr_sequencial == 3029) {
        return true;
      }

      if (filial.fornecExt === "S") {
        return false;
      }

      return true;
    },
    items() {
      return this.$store.getters["osItem/itemsPreventiva"];
    },
    showButtonInicial() {
      if (this.os.dt_inicial) {
        return false;
      }

      return true;
    },
    osEmPause() {
      if (this.os.st_os_pause) {
        return true;
      }

      return false;
    },
    isEncerrada() {
      return this.os && this.os.st_os && this.os.st_os !== "A" && this.os.st_os !== "R";
    }
  },
  methods: {
    parar() {},

    validaAnexoObrigatorio() {
      // let servicoObrigatorioAnexo = true
      // if(servicoObrigatorioAnexo) {
      // } else {
      //     this.acaoPreventiva('encerrar')
      // }
    },
    finalizarPreventivaComAnexo(objFinalizacao) {
      if (document.getElementById("btnFormFiles") != null) {
        document.getElementById("btnFormFiles").click();
      }

      // console.log(objFinalizacao.objFinalizacao.km_veiculo)

      this.km_veiculo = objFinalizacao.objFinalizacao.km_veiculo;
      this.obsExterna = objFinalizacao.objFinalizacao.obsExterna;
      this.showUploadPecas = false;
      this.acaoPreventiva("encerrar");
    },
    continuarPreventiva() {
      if (this.isEncerrada) {
        this.$swal.fire({
          title: "Atenção!",
          text: this.$t("Esta Ordem de Serviço já foi encerrada no GINFO. O atendimento não pode mais ser alterado."),
          icon: "warning"
        });
        return;
      }

      let validaOsExterna = false;

      if (this.os.st_origem == "E") {
        validaOsExterna = true;
      }

      this.$root.confirmIdentity(
        {
          onConfirmIdentity: tecnicoId => {
            const execucao = {
              nr_seq_os: this.$route.params.id,
              tecnicoId: tecnicoId
            };

            const data = {
              idMecanico: tecnicoId,
              nr_os: this.$route.params.id
            };

            this.$store
              .dispatch("osItemExecucao/validateFromOsIniciadas", {
                data: data
              })
              .then(response => {
                if (response.data.osEmAtendimento) {
                  this.$swal.fire({
                    title: "Oops!",
                    text: "Esta OS já está em atendimento!",
                    icon: "error"
                  });

                  return false;
                }

                if (
                  response.data.itemExecucao ||
                  response.data.preventiva !== null
                ) {
                  this.$swal.fire({
                    title: "Oops!",
                    text:
                      "Você já está atendendo outra OS, encerre ela para iniciar outra!",
                    icon: "error"
                  });
                  this.disabledPeca = false;

                  return false;
                }
                this.$store
                  .dispatch("osItem/continuarPreventiva", { data: execucao })
                  .then(response => {
                    this.reloadOs();
                  });
              });
          }
        },
        validaOsExterna
      );
    },
    pausarPreventiva() {
      if (this.isEncerrada) {
        this.$swal.fire({
          title: "Atenção!",
          text: this.$t("Esta Ordem de Serviço já foi encerrada no GINFO. O atendimento não pode mais ser alterado."),
          icon: "warning"
        });
        return;
      }

      let validaOsExterna = false;

      if (this.os.st_origem == "E") {
        validaOsExterna = true;
      }

      this.$root.confirmIdentity(
        {
          onConfirmIdentity: tecnicoId => {
            this.$swal
              .fire({
                title: "Informe a Justificativa",
                html:
                  '<select class="custom-select custom-select-lg mb-3" id="selectJustificativa"><option selected>Justificativa</option><option value="Ir ao banheiro">Ir ao banheiro</option><option value="Atendimento">Atendimento</option><option value="Refeicao">Refeição</option><option value="Aguardando Peças">Aguardando Peças</option><option value="Auxílio externo">Auxílio externo</option></select>',
                showCancelButton: true,
                cancelButtonColor: "#d33",
                cancelButtonText: "Cancelar",
                confirmButtonText: "Confirmar Pausa"
              })
              .then(result => {
                if (result.value) {
                  if (
                    document.getElementById("selectJustificativa").value ===
                    "Justificativa"
                  ) {
                    this.$swal.fire(
                      "Oops!",
                      "Informe uma Justificativa",
                      "error"
                    );
                  } else {
                    const execucao = {
                      nr_seq_os: this.$route.params.id,
                      justificativa: document.getElementById(
                        "selectJustificativa"
                      ).value,
                      tecnicoId: tecnicoId
                    };

                    this.$store
                      .dispatch("osItem/pausarPreventiva", { data: execucao })
                      .then(response => {
                        this.reloadOs();
                      })
                      .catch(() => {
                        this.$swal.fire({
                          title: "Oops!",
                          text: "Falha ao pausar execução. Tente novamente.",
                          icon: "error"
                        });

                        return false;
                      });
                  }
                }
              })
              .catch(erro => {
                console.log("error", erro);
                this.$swal.fire("Oops!", "Falha ao pausar", "error");
              });
          }
        },
        validaOsExterna
      );
    },
    reloadOs() {
      this.$store.dispatch("os/getDetails", {
        nrSequencial: this.$route.params.id
      });
    },
    modalPecasShow() {
      this.$store
        .dispatch("osItem/fetchFromApiPreventiva", {
          nrSeqOs: this.$route.params.id
        })
        .then(response => {
          this.allItems = response.data.items;
        });
    },
    showModalServicosMethod() {
      this.$store.dispatch("osItem/fetchFromApiPreventiva", {
        nrSeqOs: this.$route.params.id
      });

      this.showModalServicos = true;
    },
    submitPreventiva(execucao) {
      this.$store
        .dispatch("osItemExecucao/iniciaPreventiva", { data: execucao })
        .then(response => {
          this.$store.dispatch("os/getDetails", {
            nrSequencial: this.$route.params.id
          });
          this.$store.dispatch("osItemExecucao/fetchIniciadasFromApi");

          this.$store.dispatch("osItem/notificacao", {
            nr_seq_os: this.$route.params.id
          });

          if (execucao.acao == "encerrar") {
            window.location.href = "/osPreventiva";
          }
        })
        .catch(error => {
          console.log(error);
        });
    },

    acaoPreventiva(acao) {
      if (this.isEncerrada) {
        this.$swal.fire({
          title: "Atenção!",
          text: this.$t("Esta Ordem de Serviço já foi encerrada no GINFO. O atendimento não pode mais ser alterado."),
          icon: "warning"
        });
        return;
      }

      const filial = this.$store.getters["filial/filial"];

      if (acao == "iniciar") {
        if (
          (this.os.nr_seq_tipo == "V" || this.os.nr_seq_tipo == "R") &&
          this.os.st_origem == "E" &&
          (filial.atendeOs == "" || filial.atendeOs == "N")
        ) {
          // executar a função como ADM
          const execucao = {
            nrSeqOs: this.$route.params.id,
            acao: acao,
            tecnicoId: this.os.nr_seq_fornecedor
          };
          this.submitPreventiva(execucao);
        } else {
          this.$root.confirmIdentity({
            onConfirmIdentity: tecnicoId => {
              const data = {
                idMecanico: tecnicoId,
                nr_os: this.$route.params.id
              };

              this.$store
                .dispatch("osItemExecucao/validateFromOsIniciadas", {
                  data: data
                })
                .then(response => {
                  if (response.data.osEmAtendimento) {
                    this.$swal.fire({
                      title: "Oops!",
                      text: "Esta OS já está em atendimento!",
                      icon: "error"
                    });

                    return false;
                  }

                  const filial = this.$store.getters["filial/filial"];

                  let validaOsEncerrada = false;

                  if (response.data.itemExecucao != null) {
                    validaOsEncerrada = true;

                    if (
                      (response.data.itemExecucao.item.os.st_os == "E" &&
                        response.data.itemExecucao.item.os.st_origem == "I") ||
                      filial.atendeOs == "N"
                    ) {
                      validaOsEncerrada = false;
                    }
                  } else {
                    validaOsEncerrada = false;
                  }

                  if (
                    (response.data.itemExecucao || response.data.preventiva) &&
                    filial.fornecExt == null &&
                    validaOsEncerrada &&
                    filial.location != "M"
                  ) {
                    this.$swal.fire({
                      title: "Oops!",
                      html: `Você já está atendendo as OS N°: ${response.data.itemExecucao.item.os.nr_sequencial} <br>Encerre ou pause para iniciar outra!`,
                      icon: "warning"
                    });
                    this.disabledPeca = false;
                  } else {
                    const execucao = {
                      nrSeqOs: this.$route.params.id,
                      acao: acao,
                      tecnicoId: tecnicoId
                    };
                    this.submitPreventiva(execucao);
                  }
                });
            }
          });
        }
      } else {
        if (
          (this.os.nr_seq_tipo == "V" || this.os.nr_seq_tipo == "R") &&
          this.os.st_origem == "E" &&
          (filial.atendeOs == "" || filial.atendeOs == "N")
        ) {
          // executar a função como ADM

          this.$store
            .dispatch("osItemExecucao/countItensAtendidos", {
              nrSequencial: this.$route.params.id
            })
            .then(response => {
              // console.log(this.km_veiculo)

              let tecnicoId = this.os.nr_seq_fornecedor;
              const execucao = {
                nrSeqOs: this.$route.params.id,
                acao: acao,
                tecnicoId: tecnicoId,
                km_veiculo: this.km_veiculo,
                obs_externa: this.obsExterna
              };

              if (response.data) {
                this.submitPreventiva(execucao);
              } else {
                this.$swal.fire({
                  title: "Oops!",
                  text:
                    this.$t("Finalize todas as peças e serviços para encerrar o atendimento"),
                  icon: "error"
                });
              }
            });
        } else {
          this.$root.confirmIdentity({
            onConfirmIdentity: tecnicoId => {
              this.$store
                .dispatch("osItemExecucao/countItensAtendidos", {
                  nrSequencial: this.$route.params.id
                })
                .then(response => {
                  this.enabledIniciar = false;

                  const execucao = {
                    nrSeqOs: this.$route.params.id,
                    acao: acao,
                    tecnicoId: tecnicoId,
                    km_veiculo: this.km_veiculo,
                    obs_externa: this.obsExterna
                  };

                  if (response.data) {
                    // console.log(execucao)
                    this.submitPreventiva(execucao);
                  } else {
                    this.$swal.fire({
                      title: "Oops!",
                      text:
                        this.$t("Finalize todas as peças e serviços para encerrar o atendimento"),
                      icon: "error"
                    });
                  }
                });
            }
          });
        }
      }
    },
    limparArrayServicos() {
      this.totalServicos.length = 0;
    },

    registrarServicos() {
      if (this.isEncerrada) {
        this.$swal.fire({
          title: "Atenção!",
          text: this.$t("Esta Ordem de Serviço já foi encerrada no GINFO. O atendimento não pode mais ser alterado."),
          icon: "warning"
        });
        return;
      }
      // if (this.todosItensTrue() == this.todosItensPecas()) {
      // this.$emit('showModalServicos')
      const filial = this.$store.getters["filial/filial"];

      if (
        (this.os.nr_seq_tipo == "V" || this.os.nr_seq_tipo == "R") &&
        this.os.st_origem == "E" &&
        (filial.atendeOs == "" || filial.atendeOs == "N")
      ) {
        this.$store
          .dispatch("os/getDetails", {
            nrSequencial: this.$route.params.id
          })
          .then(response => {
            // if (true) {
            const execucao = {
              todosServicos: this.totalServicos,
              nrSeqOs: this.$route.params.id,
              tecnicoId: this.os.nr_seq_fornecedor,
              dt_inicial: response.data.dt_inicial
            };

            this.$store
              .dispatch("osItemExecucao/registrarServicos", { data: execucao })
              .then(response => {
                this.$store.dispatch("osItem/fetchFromApiPreventiva", {
                  nrSeqOs: this.$route.params.id
                });
                this.$swal.fire({
                  title: "Sucesso!",
                  text: this.$t("Serviços registrado com sucesso"),
                  icon: "success"
                });
              })
              .catch(error => {
                console.log(error);
              });
          });
      } else {
        this.$root.confirmIdentity(
          {
            onConfirmIdentity: tecnicoId => {
              this.$store
                .dispatch("os/getDetails", {
                  nrSequencial: this.$route.params.id
                })
                .then(response => {
                  // if (true) {
                  const execucao = {
                    todosServicos: this.totalServicos,
                    nrSeqOs: this.$route.params.id,
                    tecnicoId: tecnicoId,
                    dt_inicial: response.data.dt_inicial
                  };

                  this.$store
                    .dispatch("osItemExecucao/registrarServicos", {
                      data: execucao
                    })
                    .then(response => {
                      this.$store.dispatch("osItem/fetchFromApiPreventiva", {
                        nrSeqOs: this.$route.params.id
                      });
                      this.$swal.fire({
                        title: "Sucesso!",
                        text: this.$t("Serviços registrado com sucesso"),
                        icon: "success"
                      });
                    })
                    .catch(error => {
                      console.log(error);
                    });
                });
            }
          },
          this.validaOsExterna
        );
      }

      // } else {
      //     this.$swal.fire({
      //         title: 'Oops!',
      //         text: 'Selecione todos os serviços!',
      //         icon: 'error'
      //     })
      // }
    },

    todosItensPecas() {
      const allItens = this.$store.getters["osItem/itemsPreventiva"];

      let validador = [];

      allItens.forEach(item => {
        if (item.item.tipo.nr_sequencial == 3) {
          validador.push(item);
        }
      });

      return validador.length;
    },

    selecionarTodos(){
      const allCheckBox = document.querySelectorAll(".checkServicos");
      this.btnCheckedServicos = !this.btnCheckedServicos

      allCheckBox.forEach(item => {
        item.click()
      })
    },

    todosItensTrue() {
      const allCheckBox = document.querySelectorAll(".checkServicos");

      let validador = [];

      allCheckBox.forEach(checkBox => {
        if (checkBox.checked) {
          validador.push(checkBox);
        }
      });

      return validador.length;
    },

    insertArrayServicos(value) {
      if (!this.totalServicos.includes(value)) {
        this.totalServicos.push(value);
      } else {
        const index = this.totalServicos.indexOf(value);

        this.totalServicos.splice(index, 1);
      }

      console.log(this.totalServicos);
    },

    abrirModalPreventiva() {
      this.$bvModal.show('ModalItemsPreventiva')
    },
    enviaOsExterna(execucao) {
      console.log('os externa:', execucao);
      this.$store.dispatch('os/osExterna', { data: execucao, }).then(response => {
        window.location.href = '/'
      }).catch((error) => {
        this.$swal.fire({
          title: 'Oops!',
          text: 'Já existe uma OS externa idêntica aberta no sistema!',
          icon: 'error'
        });
      });
    }
  },
  created() {
    this.modalPecasShow();
  },
};
</script>
<style>
input[type=checkbox] {
  transform: scale(1.5)!important;
}
</style>
